import {
  type FC
} from 'react';
import {
  createPortal
} from 'react-dom';
import {
  Stack
} from '@mui/joy';
import {
  alpha
} from '@mui/system';
import {
  selectShowLoader,
  useCircularLoaderSelector
} from '../model';
import {
  SimpleCircularLoader
} from './simple-circular-loader.component';

export const CircularLoader: FC = () => {
  const loaderRoot = document.getElementById('loader-root');
  const showLoader = useCircularLoaderSelector(selectShowLoader);
  return showLoader && loaderRoot && createPortal((
    <Stack
      justifyContent='center'
      alignItems='center'
      sx={({ palette }) => ({
        position: 'absolute',
        height: '100vh',
        width: '100vw',
        zIndex: 100000000,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: `${alpha(palette.common[1450], 0.5)}`
      })}>
      <SimpleCircularLoader />
    </Stack>
  ), loaderRoot);
};